import { useSettings } from '../index'

export default function (pageName: PageName): UseLayoutPreference {
   const {
      isLoading,
      isUpdating,
      settings,
      update: updateSettings,
   } = useSettings()

   const layoutPreferencesAsJSON = settings?.LayoutPreferences
      ? JSON.parse(settings?.LayoutPreferences)
      : {}

   const update = (preference: LayoutPreference) => {
      const newLayoutPreferences = preference
         ? {
              ...layoutPreferencesAsJSON,
              ...preference,
           }
         : layoutPreferencesAsJSON

      updateSettings({
         ...settings,
         LayoutPreferences: JSON.stringify(newLayoutPreferences),
      })
   }

   return {
      isLoading: isLoading || isUpdating,
      layoutPreference: layoutPreferencesAsJSON[pageName],
      updateLayoutPreference: update,
   }
}
